import Vue from 'vue';
import { cloneDeep } from 'lodash';

// No.8 Phase 4：管理者 問合せ履歴 一覧の検索・ページング・ソート状態（agentSearch.js 踏襲）
// 詳細へ遷移してもコンポーネント外に状態が残るため、一覧へ戻ったときに条件が消えない。
// 件数（totalRows）は持たない＝全件取得してフロントで絞り込む方式のため画面側で導出できる。
const INIT_DATA = {
  currentPage: 1,
  perPage: 10,
  filter: {
    name: '',
    // null=未選択（すべて）
    status: null,
    senderCategory: null,
  },
  // 既定：最終更新日時の降順（直近が上）
  sortBy: 'updated_at',
  sortDesc: true,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_DATA),
  mutations: {
    setFilter(state, param) {
      Vue.set(state.filter, param.key, param.value);
      // 絞り込み条件が変わったら1ページ目に戻す（空ページ表示の回避）
      state.currentPage = 1;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setPerPage(state, num) {
      state.perPage = num;
      state.currentPage = 1;
    },
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
    initFilter(state) {
      Vue.set(state, 'filter', cloneDeep(INIT_DATA.filter));
      state.currentPage = INIT_DATA.currentPage;
      state.perPage = INIT_DATA.perPage;
      state.sortBy = INIT_DATA.sortBy;
      state.sortDesc = INIT_DATA.sortDesc;
    },
  },
  actions: {
  },
};
